/*!
 * @license
 * Copyright Squiz Australia Pty Ltd. All Rights Reserved.
 */

import React from 'react';

/**
 * Custom image file icon.
 * @export
 */

export const CUSTOM_FILE_IMAGE_ICON = (
  <svg fill="none" height="24" viewBox="0 0 24 24" width="24" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M21 17.5H21.5V17V4C21.5 3.17157 20.8284 2.5 20 2.5H4C3.17157 2.5 2.5 3.17157 2.5 4V17V17.5H3H21Z"
      fill="#CCE2F6"
      stroke="#74B1E6"
    />
    <circle cx="15.5" cy="8.5" fill="#FBEFD2" r="3" stroke="#F0C14F" />
    <path
      d="M21.3749 16.0025L21.5 16.1443V16.3333V20C21.5 20.8284 20.8284 21.5 20 21.5H11.5H10.3494L11.1345 20.6588L17.3826 13.9644C17.987 13.3168 19.0179 13.3313 19.604 13.9954L21.3749 16.0025Z"
      fill="#CEE9D8"
      stroke="#79C292"
    />
    <path
      d="M2.62777 13.6262L2.5 13.7686V13.96V20C2.5 20.8284 3.17157 21.5 4 21.5H17H18.0974L17.3773 20.6719L8.12033 10.0264C7.52844 9.34572 6.47399 9.33763 5.87173 10.0091L2.62777 13.6262Z"
      fill="#79C292"
      stroke="#098934"
    />
  </svg>
);
